import { HttpClient } from '@angular/common/http';
import { Observable, ObservableInput, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class ConfigService {
  public configFile: string = "appsettings.json";
  public apiEndPoint: string;
  public loginEndPoint: string;
  /** Chronodesk WhatsApp API (separate from main apiEndPoint) */
  public whatsappApiEndPoint: string;
  public formsApiEndPoint: string;
  /** Chronodesk AI Command API (separate from main apiEndPoint) */
  public aiCommandApiEndPoint: string;
  public turnstileEnabled: boolean = false;
  public turnstileSiteKey: string = '';

  constructor(private http: HttpClient) {

  }

  public init(): (() => Promise<boolean>) {

    return this.loadSettings();
  }

  public loadSettings(): (() => Promise<boolean>) {

    return (): Promise<boolean> => {
      return new Promise<boolean>((resolve: (a: boolean) => void): void => {
        this.http.get(this.configFile)
          .pipe(
            map((x: any) => {
             
              this.apiEndPoint = x.Connections.apiEndPoint;
              this.loginEndPoint = x.Connections.loginEndPoint;
              this.whatsappApiEndPoint = x.Connections?.whatsappApiEndPoint;
              this.formsApiEndPoint = x.Connections.formsApiEndPoint;
              this.aiCommandApiEndPoint = x.Connections?.aiCommandApiEndPoint;
              this.turnstileEnabled = x.Turnstile?.Enabled ?? false;
              this.turnstileSiteKey = x.Turnstile?.SiteKey ?? '';

              if (this.apiEndPoint == undefined) {
                resolve(false);
              }
              else
                resolve(true);

              console.log("Login end point");
              console.log(this.loginEndPoint);
            }),
            catchError((x: { status: number }, caught: Observable<void>): ObservableInput<{}> => {

              console.debug("ConfigService:", 'ERROR GETTING API URL');
              console.debug("ConfigService:", x);

              if (x.status !== 404) {
                resolve(false);
              }
              resolve(false);
              return of({});
            })
          ).subscribe();
      });
    };
  }
}
